import React from 'react';

const BannerPortalContext = React.createContext(null);

export default BannerPortalContext;